'use strict';

var React = require('react');
var index = require('../Flex/index.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const TreeRoot = React.forwardRef(({ children, space = 'm', ...props }, ref) => (React__default.default.createElement(styles.Styled.Ul, { ...props, ref: ref },
    React__default.default.createElement(index.Flex.Column, { space: space }, children))));
TreeRoot.displayName = 'Tree.Root';

exports.TreeRoot = TreeRoot;
//# sourceMappingURL=Root.js.map
